import { useTranslation } from "react-i18next";
import { PhoneNumberInput } from "../../core/components/input/PhoneNumberInput";
import { InfoText } from "../../core/components/texts/InfoText";
import {
  getAppointmentCountryCode,
  getAppointmentNationalPhone,
} from "../../core/store/appointmentSlice";
import { useMainStore } from "../../core/store/mainStore";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";

export const AppointmentPhoneNumberScreen = () => {
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();
  const appointmentNationalPhone = useMainStore(getAppointmentNationalPhone);
  const setAppointmentNationalPhone = useMainStore(
    (state) => state.setAppointmentNationalPhone,
  );

  const appointmentCountryCode = useMainStore(getAppointmentCountryCode);
  const setAppointmentCountryCode = useMainStore(
    (state) => state.setAppointmentCountryCode,
  );

  const handleNext = () => {
    navigate();
  };

  return (
    <AppointmentScreenWrapper
      onNext={handleNext}
      nextButtonDisabled={!appointmentNationalPhone || !appointmentCountryCode}>
      <InfoText
        headline={t("APPOINTMENT_PHONE_NUMBER_SCREEN_TITLE")}
        text={[t("APPOINTMENT_PHONE_NUMBER_SCREEN_DESCRIPTION")]}
      />
      <PhoneNumberInput
        setPhoneNumber={setAppointmentNationalPhone}
        phoneNumber={appointmentNationalPhone || ""}
        setPhoneCountry={setAppointmentCountryCode}
        phoneCountry={appointmentCountryCode || ""}
      />
    </AppointmentScreenWrapper>
  );
};
